const states = [
  { name: 'Alabama', abbreviation: 'AL' },
  { name: 'Alaska', abbreviation: 'AK' },
  { name: 'Arizona', abbreviation: 'AZ' },
  { name: 'Arkansas', abbreviation: 'AR' },
  { name: 'California', abbreviation: 'CA' },
  { name: 'Colorado', abbreviation: 'CO' },
  { name: 'Connecticut', abbreviation: 'CT' },
  { name: 'District of Columbia', abbreviation: 'DC' },
  { name: 'Delaware', abbreviation: 'DE' },
  { name: 'Florida', abbreviation: 'FL' },
  { name: 'Georgia', abbreviation: 'GA' },
  { name: 'Hawaii', abbreviation: 'HI' },
  { name: 'Idaho', abbreviation: 'ID' },
  { name: 'Illinois', abbreviation: 'IL' },
  { name: 'Indiana', abbreviation: 'IN' },
  { name: 'Iowa', abbreviation: 'IA' },
  { name: 'Kansas', abbreviation: 'KS' },
  { name: 'Kentucky', abbreviation: 'KY' },
  { name: 'Louisiana', abbreviation: 'LA' },
  { name: 'Maine', abbreviation: 'ME' },
  { name: 'Maryland', abbreviation: 'MD' },
  { name: 'Massachusetts', abbreviation: 'MA' },
  { name: 'Michigan', abbreviation: 'MI' },
  { name: 'Minnesota', abbreviation: 'MN' },
  { name: 'Mississippi', abbreviation: 'MS' },
  { name: 'Missouri', abbreviation: 'MO' },
  { name: 'Montana', abbreviation: 'MT' },
  { name: 'Nebraska', abbreviation: 'NE' },
  { name: 'Nevada', abbreviation: 'NV' },
  { name: 'New Hampshire', abbreviation: 'NH' },
  { name: 'New Jersey', abbreviation: 'NJ' },
  { name: 'New Mexico', abbreviation: 'NM' },
  { name: 'New York', abbreviation: 'NY' },
  { name: 'North Carolina', abbreviation: 'NC' },
  { name: 'North Dakota', abbreviation: 'ND' },
  { name: 'Ohio', abbreviation: 'OH' },
  { name: 'Oklahoma', abbreviation: 'OK' },
  { name: 'Oregon', abbreviation: 'OR' },
  { name: 'Pennsylvania', abbreviation: 'PA' },
  { name: 'Rhode Island', abbreviation: 'RI' },
  { name: 'South Carolina', abbreviation: 'SC' },
  { name: 'South Dakota', abbreviation: 'SD' },
  { name: 'Tennessee', abbreviation: 'TN' },
  { name: 'Texas', abbreviation: 'TX' },
  { name: 'Utah', abbreviation: 'UT' },
  { name: 'Vermont', abbreviation: 'VT' },
  { name: 'Virginia', abbreviation: 'VA' },
  { name: 'Washington', abbreviation: 'WA' },
  { name: 'West Virginia', abbreviation: 'WV' },
  { name: 'Wisconsin', abbreviation: 'WI' },
  { name: 'Wyoming', abbreviation: 'WY' },
];

const provinces = [
  { name: 'Alberta', abbreviation: 'AB' },
  { name: 'British Columbia', abbreviation: 'BC' },
  { name: 'Manitoba', abbreviation: 'MB' },
  { name: 'New Brunswick', abbreviation: 'NB' },
  { name: 'Newfoundland and Labrador', abbreviation: 'NL' },
  { name: 'Northwest Territories', abbreviation: 'NT' },
  { name: 'Nova Scotia', abbreviation: 'NS' },
  { name: 'Nunavut', abbreviation: 'NU' },
  { name: 'Ontario', abbreviation: 'ON' },
  { name: 'Prince Edward Island', abbreviation: 'PE' },
  { name: 'Quebec', abbreviation: 'QC' },
  { name: 'Saskatchewan', abbreviation: 'SK' },
  { name: 'Yukon Territory', abbreviation: 'YT' },
];

// The original list can be found here: https://github.com/lukes/ISO-3166-Countries-with-Regional-Codes/blob/master/slim-2/slim-2.json
const countries = [
  { name: 'United States of America', abbreviation: 'us' },
  { name: 'Afghanistan', abbreviation: 'af' },
  { name: 'Åland Islands', abbreviation: 'ax' },
  { name: 'Albania', abbreviation: 'al' },
  { name: 'Algeria', abbreviation: 'dz' },
  { name: 'American Samoa', abbreviation: 'as' },
  { name: 'Andorra', abbreviation: 'ad' },
  { name: 'Angola', abbreviation: 'ao' },
  { name: 'Anguilla', abbreviation: 'ai' },
  { name: 'Antarctica', abbreviation: 'aq' },
  { name: 'Antigua and Barbuda', abbreviation: 'ag' },
  { name: 'Argentina', abbreviation: 'ar' },
  { name: 'Armenia', abbreviation: 'am' },
  { name: 'Aruba', abbreviation: 'aw' },
  { name: 'Australia', abbreviation: 'au' },
  { name: 'Austria', abbreviation: 'at' },
  { name: 'Azerbaijan', abbreviation: 'az' },
  { name: 'Bahamas', abbreviation: 'bs' },
  { name: 'Bahrain', abbreviation: 'bh' },
  { name: 'Bangladesh', abbreviation: 'bd' },
  { name: 'Barbados', abbreviation: 'bb' },
  { name: 'Belarus', abbreviation: 'by' },
  { name: 'Belgium', abbreviation: 'be' },
  { name: 'Belize', abbreviation: 'bz' },
  { name: 'Benin', abbreviation: 'bj' },
  { name: 'Bermuda', abbreviation: 'bm' },
  { name: 'Bhutan', abbreviation: 'bt' },
  { name: 'Bolivia, Plurinational State of', abbreviation: 'bo' },
  { name: 'Bonaire, Sint Eustatius and Saba', abbreviation: 'bq' },
  { name: 'Bosnia and Herzegovina', abbreviation: 'ba' },
  { name: 'Botswana', abbreviation: 'bw' },
  { name: 'Bouvet Island', abbreviation: 'bv' },
  { name: 'Brazil', abbreviation: 'br' },
  { name: 'British Indian Ocean Territory', abbreviation: 'io' },
  { name: 'Brunei Darussalam', abbreviation: 'bn' },
  { name: 'Bulgaria', abbreviation: 'bg' },
  { name: 'Burkina Faso', abbreviation: 'bf' },
  { name: 'Burundi', abbreviation: 'bi' },
  { name: 'Cabo Verde', abbreviation: 'cv' },
  { name: 'Cambodia', abbreviation: 'kh' },
  { name: 'Cameroon', abbreviation: 'cm' },
  { name: 'Canada', abbreviation: 'ca' },
  { name: 'Cayman Islands', abbreviation: 'ky' },
  { name: 'Central African Republic', abbreviation: 'cf' },
  { name: 'Chad', abbreviation: 'td' },
  { name: 'Chile', abbreviation: 'cl' },
  { name: 'China', abbreviation: 'cn' },
  { name: 'Christmas Island', abbreviation: 'cx' },
  { name: 'Cocos (Keeling) Islands', abbreviation: 'cc' },
  { name: 'Colombia', abbreviation: 'co' },
  { name: 'Comoros', abbreviation: 'km' },
  { name: 'Congo', abbreviation: 'cg' },
  { name: 'Congo, Democratic Republic of the', abbreviation: 'cd' },
  { name: 'Cook Islands', abbreviation: 'ck' },
  { name: 'Costa Rica', abbreviation: 'cr' },
  { name: "Côte d'Ivoire", abbreviation: 'ci' },
  { name: 'Croatia', abbreviation: 'hr' },
  { name: 'Cuba', abbreviation: 'cu' },
  { name: 'Curaçao', abbreviation: 'cw' },
  { name: 'Cyprus', abbreviation: 'cy' },
  { name: 'Czechia', abbreviation: 'cz' },
  { name: 'Denmark', abbreviation: 'dk' },
  { name: 'Djibouti', abbreviation: 'dj' },
  { name: 'Dominica', abbreviation: 'dm' },
  { name: 'Dominican Republic', abbreviation: 'do' },
  { name: 'Ecuador', abbreviation: 'ec' },
  { name: 'Egypt', abbreviation: 'eg' },
  { name: 'El Salvador', abbreviation: 'sv' },
  { name: 'Equatorial Guinea', abbreviation: 'gq' },
  { name: 'Eritrea', abbreviation: 'er' },
  { name: 'Estonia', abbreviation: 'ee' },
  { name: 'Eswatini', abbreviation: 'sz' },
  { name: 'Ethiopia', abbreviation: 'et' },
  { name: 'Falkland Islands (Malvinas)', abbreviation: 'fk' },
  { name: 'Faroe Islands', abbreviation: 'fo' },
  { name: 'Fiji', abbreviation: 'fj' },
  { name: 'Finland', abbreviation: 'fi' },
  { name: 'France', abbreviation: 'fr' },
  { name: 'French Guiana', abbreviation: 'gf' },
  { name: 'French Polynesia', abbreviation: 'pf' },
  { name: 'French Southern Territories', abbreviation: 'tf' },
  { name: 'Gabon', abbreviation: 'ga' },
  { name: 'Gambia', abbreviation: 'gm' },
  { name: 'Georgia', abbreviation: 'ge' },
  { name: 'Germany', abbreviation: 'de' },
  { name: 'Ghana', abbreviation: 'gh' },
  { name: 'Gibraltar', abbreviation: 'gi' },
  { name: 'Greece', abbreviation: 'gr' },
  { name: 'Greenland', abbreviation: 'gl' },
  { name: 'Grenada', abbreviation: 'gd' },
  { name: 'Guadeloupe', abbreviation: 'gp' },
  { name: 'Guam', abbreviation: 'gu' },
  { name: 'Guatemala', abbreviation: 'gt' },
  { name: 'Guernsey', abbreviation: 'gg' },
  { name: 'Guinea', abbreviation: 'gn' },
  { name: 'Guinea-Bissau', abbreviation: 'gw' },
  { name: 'Guyana', abbreviation: 'gy' },
  { name: 'Haiti', abbreviation: 'ht' },
  { name: 'Heard Island and McDonald Islands', abbreviation: 'hm' },
  { name: 'Holy See', abbreviation: 'va' },
  { name: 'Honduras', abbreviation: 'hn' },
  { name: 'Hong Kong', abbreviation: 'hk' },
  { name: 'Hungary', abbreviation: 'hu' },
  { name: 'Iceland', abbreviation: 'is' },
  { name: 'India', abbreviation: 'in' },
  { name: 'Indonesia', abbreviation: 'id' },
  { name: 'Iran, Islamic Republic of', abbreviation: 'ir' },
  { name: 'Iraq', abbreviation: 'iq' },
  { name: 'Ireland', abbreviation: 'ie' },
  { name: 'Isle of Man', abbreviation: 'im' },
  { name: 'Israel', abbreviation: 'il' },
  { name: 'Italy', abbreviation: 'it' },
  { name: 'Jamaica', abbreviation: 'jm' },
  { name: 'Japan', abbreviation: 'jp' },
  { name: 'Jersey', abbreviation: 'je' },
  { name: 'Jordan', abbreviation: 'jo' },
  { name: 'Kazakhstan', abbreviation: 'kz' },
  { name: 'Kenya', abbreviation: 'ke' },
  { name: 'Kiribati', abbreviation: 'ki' },
  { name: "Korea, Democratic People's Republic of", abbreviation: 'kp' },
  { name: 'Korea, Republic of', abbreviation: 'kr' },
  { name: 'Kuwait', abbreviation: 'kw' },
  { name: 'Kyrgyzstan', abbreviation: 'kg' },
  { name: "Lao People's Democratic Republic", abbreviation: 'la' },
  { name: 'Latvia', abbreviation: 'lv' },
  { name: 'Lebanon', abbreviation: 'lb' },
  { name: 'Lesotho', abbreviation: 'ls' },
  { name: 'Liberia', abbreviation: 'lr' },
  { name: 'Libya', abbreviation: 'ly' },
  { name: 'Liechtenstein', abbreviation: 'li' },
  { name: 'Lithuania', abbreviation: 'lt' },
  { name: 'Luxembourg', abbreviation: 'lu' },
  { name: 'Macao', abbreviation: 'mo' },
  { name: 'Madagascar', abbreviation: 'mg' },
  { name: 'Malawi', abbreviation: 'mw' },
  { name: 'Malaysia', abbreviation: 'my' },
  { name: 'Maldives', abbreviation: 'mv' },
  { name: 'Mali', abbreviation: 'ml' },
  { name: 'Malta', abbreviation: 'mt' },
  { name: 'Marshall Islands', abbreviation: 'mh' },
  { name: 'Martinique', abbreviation: 'mq' },
  { name: 'Mauritania', abbreviation: 'mr' },
  { name: 'Mauritius', abbreviation: 'mu' },
  { name: 'Mayotte', abbreviation: 'yt' },
  { name: 'Mexico', abbreviation: 'mx' },
  { name: 'Micronesia, Federated States of', abbreviation: 'fm' },
  { name: 'Moldova, Republic of', abbreviation: 'md' },
  { name: 'Monaco', abbreviation: 'mc' },
  { name: 'Mongolia', abbreviation: 'mn' },
  { name: 'Montenegro', abbreviation: 'me' },
  { name: 'Montserrat', abbreviation: 'ms' },
  { name: 'Morocco', abbreviation: 'ma' },
  { name: 'Mozambique', abbreviation: 'mz' },
  { name: 'Myanmar', abbreviation: 'mm' },
  { name: 'Namibia', abbreviation: 'na' },
  { name: 'Nauru', abbreviation: 'nr' },
  { name: 'Nepal', abbreviation: 'np' },
  { name: 'Netherlands, Kingdom of the', abbreviation: 'nl' },
  { name: 'New Caledonia', abbreviation: 'nc' },
  { name: 'New Zealand', abbreviation: 'nz' },
  { name: 'Nicaragua', abbreviation: 'ni' },
  { name: 'Niger', abbreviation: 'ne' },
  { name: 'Nigeria', abbreviation: 'ng' },
  { name: 'Niue', abbreviation: 'nu' },
  { name: 'Norfolk Island', abbreviation: 'nf' },
  { name: 'North Macedonia', abbreviation: 'mk' },
  { name: 'Northern Mariana Islands', abbreviation: 'mp' },
  { name: 'Norway', abbreviation: 'no' },
  { name: 'Oman', abbreviation: 'om' },
  { name: 'Pakistan', abbreviation: 'pk' },
  { name: 'Palau', abbreviation: 'pw' },
  { name: 'Palestine, State of', abbreviation: 'ps' },
  { name: 'Panama', abbreviation: 'pa' },
  { name: 'Papua New Guinea', abbreviation: 'pg' },
  { name: 'Paraguay', abbreviation: 'py' },
  { name: 'Peru', abbreviation: 'pe' },
  { name: 'Philippines', abbreviation: 'ph' },
  { name: 'Pitcairn', abbreviation: 'pn' },
  { name: 'Poland', abbreviation: 'pl' },
  { name: 'Portugal', abbreviation: 'pt' },
  { name: 'Puerto Rico', abbreviation: 'pr' },
  { name: 'Qatar', abbreviation: 'qa' },
  { name: 'Réunion', abbreviation: 're' },
  { name: 'Romania', abbreviation: 'ro' },
  { name: 'Russian Federation', abbreviation: 'ru' },
  { name: 'Rwanda', abbreviation: 'rw' },
  { name: 'Saint Barthélemy', abbreviation: 'bl' },
  { name: 'Saint Helena, Ascension and Tristan da Cunha', abbreviation: 'sh' },
  { name: 'Saint Kitts and Nevis', abbreviation: 'kn' },
  { name: 'Saint Lucia', abbreviation: 'lc' },
  { name: 'Saint Martin (French part)', abbreviation: 'mf' },
  { name: 'Saint Pierre and Miquelon', abbreviation: 'pm' },
  { name: 'Saint Vincent and the Grenadines', abbreviation: 'vc' },
  { name: 'Samoa', abbreviation: 'ws' },
  { name: 'San Marino', abbreviation: 'sm' },
  { name: 'Sao Tome and Principe', abbreviation: 'st' },
  { name: 'Saudi Arabia', abbreviation: 'sa' },
  { name: 'Senegal', abbreviation: 'sn' },
  { name: 'Serbia', abbreviation: 'rs' },
  { name: 'Seychelles', abbreviation: 'sc' },
  { name: 'Sierra Leone', abbreviation: 'sl' },
  { name: 'Singapore', abbreviation: 'sg' },
  { name: 'Sint Maarten (Dutch part)', abbreviation: 'sx' },
  { name: 'Slovakia', abbreviation: 'sk' },
  { name: 'Slovenia', abbreviation: 'si' },
  { name: 'Solomon Islands', abbreviation: 'sb' },
  { name: 'Somalia', abbreviation: 'so' },
  { name: 'South Africa', abbreviation: 'za' },
  { name: 'South Georgia and the South Sandwich Islands', abbreviation: 'gs' },
  { name: 'South Sudan', abbreviation: 'ss' },
  { name: 'Spain', abbreviation: 'es' },
  { name: 'Sri Lanka', abbreviation: 'lk' },
  { name: 'Sudan', abbreviation: 'sd' },
  { name: 'Suriname', abbreviation: 'sr' },
  { name: 'Svalbard and Jan Mayen', abbreviation: 'sj' },
  { name: 'Sweden', abbreviation: 'se' },
  { name: 'Switzerland', abbreviation: 'ch' },
  { name: 'Syrian Arab Republic', abbreviation: 'sy' },
  { name: 'Taiwan, Province of China', abbreviation: 'tw' },
  { name: 'Tajikistan', abbreviation: 'tj' },
  { name: 'Tanzania, United Republic of', abbreviation: 'tz' },
  { name: 'Thailand', abbreviation: 'th' },
  { name: 'Timor-Leste', abbreviation: 'tl' },
  { name: 'Togo', abbreviation: 'tg' },
  { name: 'Tokelau', abbreviation: 'tk' },
  { name: 'Tonga', abbreviation: 'to' },
  { name: 'Trinidad and Tobago', abbreviation: 'tt' },
  { name: 'Tunisia', abbreviation: 'tn' },
  { name: 'Türkiye', abbreviation: 'tr' },
  { name: 'Turkmenistan', abbreviation: 'tm' },
  { name: 'Turks and Caicos Islands', abbreviation: 'tc' },
  { name: 'Tuvalu', abbreviation: 'tv' },
  { name: 'Uganda', abbreviation: 'ug' },
  { name: 'Ukraine', abbreviation: 'ua' },
  { name: 'United Arab Emirates', abbreviation: 'ae' },
  { name: 'United Kingdom', abbreviation: 'gb' },
  { name: 'United States Minor Outlying Islands', abbreviation: 'um' },
  { name: 'Uruguay', abbreviation: 'uy' },
  { name: 'Uzbekistan', abbreviation: 'uz' },
  { name: 'Vanuatu', abbreviation: 'vu' },
  { name: 'Venezuela, Bolivarian Republic of', abbreviation: 've' },
  { name: 'Viet Nam', abbreviation: 'vn' },
  { name: 'Virgin Islands (British)', abbreviation: 'vg' },
  { name: 'Virgin Islands (U.S.)', abbreviation: 'vi' },
  { name: 'Wallis and Futuna', abbreviation: 'wf' },
  { name: 'Western Sahara', abbreviation: 'eh' },
  { name: 'Yemen', abbreviation: 'ye' },
  { name: 'Zambia', abbreviation: 'zm' },
  { name: 'Zimbabwe', abbreviation: 'zw' },
];

const LocationUtils = {
  countries: countries,
  states: states,
  provinces: provinces,
};

export { LocationUtils };
